import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "appleLinkPipe",
})
export class AppleLinkPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return (
            "https://itunes.apple.com/app/apple-store/id1020056658?pt=117881873&ct=" +
            value +
            "&mt=8"
        );
    }
}
